import { Component } from 'react';
import gql from 'graphql-tag';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

class TermsOfServiceSubscription extends Component {
  constructor(props) {
    super(props);
    this.tosUpdateSubscription = null;
  }

  componentDidMount() {
    this.subscribeToUpdateTermsOfService();
  }

  componentWillUnmount() {
    if (this.tosUpdateSubscription) {
      this.tosUpdateSubscription.unsubscribe();
      this.tosUpdateSubscription = null;
    }
  }

  subscribeToUpdateTermsOfService() {
    if (this.tosUpdateSubscription) {
      this.tosUpdateSubscription.unsubscribe();
    }
    const that = this;
    this.tosUpdateSubscription = this.props.client
      .subscribe({
        query: SUBSCRIPTION_UPDATE_TERMS_OF_SERVICE
      })
      .subscribe({
        next(subscriptionData) {
          if (subscriptionData.data.tosUpdated) {
            that.props.redirectToTos();
          }
        },
        error(err) {
          console.error('Error in TermsOfService: ', err);
        }
      });
  }

  render() {
    return null;
  }
}

const SUBSCRIPTION_UPDATE_TERMS_OF_SERVICE = gql`
  subscription {
    updateTermsOfService {
      tosUpdated
    }
  }
`;

const mapDispatchToProps = dispatch => ({
  redirectToTos: () => dispatch(push('/terms-of-service-updated'))
});

const withConnect = connect(null, mapDispatchToProps);

export default withConnect(withApollo(TermsOfServiceSubscription));
